import { Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-image-scroll-stacking',
  templateUrl: './image-scroll-stacking.component.html',
  styleUrls: ['./image-scroll-stacking.component.scss']
})
export class ImageScrollStackingComponent {

  @Input() item: any;
  @Input() img: any;
  public serverPath = environment.commonImageApi + '/home/';
  public bannerServerPath = environment.commonImageApi + '/commonSlider/';

  constructor(
    private commonService: CommonService) { }


  ngOnInit() {

    if (this.img) {
      this.isCardActive = new Array(this.img.length).fill(false);
    }
  }


  @ViewChildren('cardElem') cardElements!: QueryList<ElementRef>;

  isCardActive: boolean[] = [];

  ngAfterViewInit() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const index = this.cardElements.toArray().findIndex(el => el.nativeElement === entry.target);
          if (index > -1) {
            this.isCardActive[index] = entry.isIntersecting;
          }
        });
      },
      { threshold: 0.6 }
    );

    this.cardElements.forEach(el => {
      this.isCardActive.push(false);
      observer.observe(el.nativeElement);
    });
  }

  goToCategories(id: any) {
    if (id > 0) {
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  link(url) {

    this.commonService.goToLink(url)

  }

}
